import { cn } from '@repo/tailwind-config/tailwind.functions'
import {
  TailwindColor,
  TailwindColorOrString,
  tailwindColors
} from '@repo/tailwind-config/tailwind.vars'
import { SVGFC } from '@repo/toolkit/types'
import React from 'react'

export type IconVariant = 'success' | 'danger' | 'primary' | 'warning'

type Props = {
  className?: string
  color?: TailwindColorOrString
  backgroundColor?: TailwindColorOrString
  variant?: IconVariant
  size?: number
  icon: SVGFC
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}

const iconVariantMapping: Record<
  IconVariant,
  {
    color: TailwindColor
    backgroundColor: TailwindColor
  }
> = {
  primary: {
    color: tailwindColors.primary.DEFAULT,
    backgroundColor: tailwindColors.primary.light.DEFAULT
  },
  success: {
    color: tailwindColors.green.DEFAULT,
    backgroundColor: tailwindColors.green.light.DEFAULT
  },
  danger: {
    color: tailwindColors.red.DEFAULT,
    backgroundColor: tailwindColors.red.light.DEFAULT
  },
  warning: {
    color: tailwindColors.secondary.DEFAULT,
    backgroundColor: tailwindColors.secondary.light.DEFAULT
  }
}

const RoundedIcon: React.FC<Props> = ({
  className,
  color,
  backgroundColor,
  size = 24,
  variant,
  icon: Icon,
  onClick
}) => {
  return (
    <div
      onClick={onClick}
      className={cn('rounded flex items-center justify-center p-0.5', className)}
      style={{
        backgroundColor: variant ? iconVariantMapping[variant].backgroundColor : backgroundColor,
        width: `${size}px`,
        height: `${size}px`,
        minWidth: `${size}px`,
        minHeight: `${size}px`
      }}
    >
      <Icon color={variant ? iconVariantMapping[variant].color : color} />
    </div>
  )
}

export default RoundedIcon
